import * as actionTypes from '../actions/actionTypes';
import { removeUserSession,getUserAuthoritiesWindow, getCurrentUserAuthoritiesWindow,windowsMenusList } from '../../Utils/UserFunctions';

const intialState = {
	authenticated : false,
	loginError : null,
	accessToken : null,
	refreshToken : null,
	userAuthorities : null,
	signupSucessmsg : null,
	signupError : null,
	signupviolationsError : null,
	requestError : null,
	responseData : null,
	selectedWindowData:[],
	redirectURL: null,
	windowsMenusList:[],
	selectedTags: null
}
// reducer
const reducer = (state = intialState, action) => {
	switch( action.type ) {
		case actionTypes.AUTHENTICATED :
			if(!action.value) {
				removeUserSession();
			}
			return {
				...state,
				authenticated : action.value
			}
		case actionTypes.LOGOUT :
			removeUserSession();
			return {
				...state,
				authenticated : false,
				loginError : null,
				accessToken : null,
				refreshToken : null,
				userAuthorities : null,
				signupSucessmsg : null,
				signupError : null,
				signupviolationsError : null,
				requestError : null,
				responseData : null,
				selectedWindowData:[],
				redirectURL: null,
				windowsMenusList:[],
				selectedTags: null
			}
		case actionTypes.AUTH_START :
			//console.log('inner')
			return {
				...state,
				loginError : null
			}
		case actionTypes.AUTH_SUCCESS :
			return {
				...state,
				authenticated : true,
				accessToken : action.authData.access_token,
				refreshToken : action.authData.refresh_token,
				selectedWindowData:[...getCurrentUserAuthoritiesWindow()]
			}
		case actionTypes.AUTH_FAIL :
			return {
				...state,
				loginError : action.error
			}
		case actionTypes.SIGNUP_START :
			return {
				...state,
				signupSucessmsg : null,
				signupError : null
			}
		case actionTypes.SIGNUP_SUCCESS :
			return {
				...state,
				signupSucessmsg : action.msg,
				signupError : null,
				signupviolationsError : null
			}
		case actionTypes.SIGNUP_FAIL :
			return {
				...state,
				signupSucessmsg : null,
				signupError : action.error,
				signupviolationsError : null
			}
		case actionTypes.SIGNUP_VIOLATIONS :
			return {
				...state,
				signupSucessmsg : null,
				signupError : null,
				signupviolationsError : action.error
			}
		case actionTypes.REQUEST_START :
			return {
				...state,
				requestError : null,
				responseData : null
			}
		case actionTypes.REQUEST_SUCCESS :
			return {
				...state,
				responseData : action.data,
				requestError : null
			}
		case actionTypes.REQUEST_FAIL :
			return {
				...state,
				requestError : action.error,
				responseData : null
			}
		case actionTypes.MODULE_CHANGE :
			// alert(action.moduleId);
			const windowData = (action.moduleId==null)? getCurrentUserAuthoritiesWindow():getUserAuthoritiesWindow(action.moduleId);
			return {
					...state,
					selectedWindowData:[...windowData]
				}	
		case actionTypes.REDIRECT_URL :
			return {
				...state,
				redirectURL : action.redirectURL
			}
		case actionTypes.CLEAR_REDIRECT_URL :
			return {
				...state,
				redirectURL : action.redirectURL
			}	
		case actionTypes.WINDOWS_MENUS_UPDATE:
			return{
				...state,
				windowsMenusList:windowsMenusList()
			}	
		case actionTypes.SET_SELECTED_TAGS:
			return{
				...state,
				selectedTags: action.value
			}				
		default :
			return state;

	}
}

export default reducer;